import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { HiOutlineX } from 'react-icons/hi';

const AlertModal = ({ visible, message, onClose }) => {
  useEffect(() => {
    if (!visible) return;

    const handleKeyDown = (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        onClose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [visible, onClose]);

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <div
        className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75"
        onClick={onClose}
      ></div>

      <div className="relative bg-white rounded-lg text-left overflow-hidden shadow-xl w-full max-w-lg">
        <div className="bg-white px-6 pt-6 pb-4">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-semibold text-gray-900">Alert</h3>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-500 transition-colors"
            >
              <HiOutlineX className="w-5 h-5" />
            </button>
          </div>
          <div className="mb-4">
            <p className="text-sm text-gray-900 whitespace-pre-line">{message}</p>
          </div>
          <div className="flex justify-end">
            <button
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors"
            >
              확인
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

AlertModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  message: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

export default AlertModal;
